import { useCallback, useRef } from 'react';
import { applySelector, initial, skipped, usePulseClient, useParseOptions, useSyncResource } from './shared';

// Overload: param-using resource WITH select

// Overload: param-using resource WITHOUT select (keep first for intellisense)
// The homomorphic mapped type seems pointless, but is required for full expected property
// checking behavior. I've tagged the relevant test in useResource-types-test.tsx
// with [homomorphic type test]
// Overload: param-less resource WITH select
// Overload: param-less resource WITHOUT select
// Implementation
export function useResource(resource, options) {
  const {
    params,
    skip,
    pollInterval,
    pollGroup,
    httpClient,
    passive,
    instanceKey
  } = useParseOptions(resource, options);
  const client = usePulseClient();
  const resourceForClient = resource;
  const select = options === null || options === void 0 ? void 0 : options.select;
  const selectRef = useRef(select);
  // eslint-disable-next-line react-hooks/refs
  selectRef.current = select;
  const cachedRef = useRef(undefined);
  const getSnapshot = useCallback(() => {
    var _client$getState;
    const raw = skip || !client ? skipped : (_client$getState = client.getState({
      resource: resourceForClient,
      params,
      instanceKey
    })) !== null && _client$getState !== void 0 ? _client$getState : initial;
    const selector = selectRef.current;
    if (!selector) {
      return raw;
    }
    const result = applySelector(raw, selector, cachedRef.current);
    cachedRef.current = {
      source: raw,
      selector,
      result
    };
    return result;
  },
  // instanceKey is a proxy for params and resource changing
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [skip, instanceKey, client]);
  return useSyncResource(getSnapshot, instanceKey, resourceForClient, params, skip, pollInterval, client, httpClient, pollGroup, passive);
}